import "./GamingSecurityWithVPNs.module.css";
import Header from "@/reusable_sections/Header";
import Gamingsecurityhero from "./sections/Gamingsecurityhero";
import Gamerddosprotection from "./sections/Gamerddosprotection";
import Streamersecurityrisks from "./sections/Streamersecurityrisks";
import RelatedArticlesProtocol from "./sections/RelatedArticlesProtocol";
import Affiliatecta from "./sections/Affiliatecta";
import Remotesecuritycta from "./sections/Remotesecuritycta";
import Footer from "@/reusable_sections/Footer";
export default function GamingSecurityWithVPNsPage() {
  return <div>
      <Header />
      <Gamingsecurityhero />
      <Gamerddosprotection />
      <Streamersecurityrisks />
      <RelatedArticlesProtocol />
      <Remotesecuritycta />
      <Affiliatecta />
      <Footer />
    </div>;
}